<template>
  <div class="layout-topbar clearfix">

    <img style="width: 15vw; max-width: 25em" alt="nio-customer-portal" class="layout-topbar-app-logo"
         src="assets/layout/images/logoNIO.png" />

    <button class="layout-menu-button p-link" @click="onMenuButtonClick">
      <i class="pi pi-bars"></i>
    </button>

    <button id="topbar-menu-button" class="p-link" @click="onTopbarMenuButtonClick">
      <i class="pi pi-ellipsis-v"></i>
    </button>

    <ul :class="topbarItemsClass">
      <li>
        <button :class="loading ? 'link-disabled' : 'p-link'"
                :disabled="loading"
                v-tooltip.bottom="$toolips.standard('Logout')"
                @click="$emit('topbar-item-click',{originalEvent:$event,item:'signout'})">
          <i :class="loading ? 'topbar-icon-disabled pi pi-sign-out' : 'topbar-icon pi pi-sign-out'"></i>
          <span class="topbar-item-name">Sign out</span>
        </button>
      </li>
      <template v-if="$methods.aclIsVisible('AppTopbar.userpreference')">
        <li role="menuitem">
          <button :class="loading ? 'link-disabled' : 'p-link'"
                  v-tooltip.bottom="$toolips.standard($t('userpreference.breadcrumb'))"
                  :disabled="loading"
                  @click="$router.currentRoute.name !== 'userpreference'? $router.push('userpreference') : null">
            <i :class="loading ? 'topbar-icon-disabled pi pi-user' : 'topbar-icon pi pi-user'"></i>
            <span class="topbar-item-name">{{ $t('userpreference.breadcrumb') }}</span>
          </button>
        </li>
      </template>
      <template v-if="$methods.aclIsVisible('AppTopbar.notifications')">
        <li role="menuitem">
          <button :class="loading ? 'link-disabled' : 'p-link'"
                  :disabled="loading"
                  v-tooltip.bottom="$toolips.standard($t('notifications.breadcrumb'))"
                  @click="$router.currentRoute.name !== 'notifications' ? this.$router.push('notifications') : null">
            <i :class="loading ? 'topbar-icon-disabled pi pi-bell' : 'topbar-icon pi pi-bell'"></i>
            <span v-if="notificationsCount > 0" class="badge">
              <AnimatedNumber :value-original="notificationsCount" :precision="0" />
          </span>
            <span class="topbar-item-name">{{ $t('notifications.breadcrumb') }}</span>
          </button>
        </li>
      </template>
      <template v-if="$methods.aclIsVisible('AppTopbar.listaPortafogli')">
        <li role="menuitem">
          <button :class="loading ? 'link-disabled' : 'p-link'"
                  v-tooltip.bottom="$toolips.standard($t('listaportafogli.breadcrumb'))"
                  :disabled="loading"
                  @click="$router.currentRoute.name !== 'lista_portafogli'? $router.push('lista_portafogli') : null">
            <i :class="loading ? 'topbar-icon-disabled pi pi-wallet':'topbar-icon pi pi-wallet'"></i>
            <span v-if="expiredCount > 0" class="badge">
              <AnimatedNumber :value-original="expiredCount" :precision="0" />
            </span>
            <span class="topbar-item-name">{{ $t('listaportafogli.breadcrumb') }}</span>
          </button>
        </li>
      </template>
      <template v-if="$methods.aclIsVisible('AppTopbar.unmatchedbuyers')">
        <li role="menuitem">
          <button :class="loading ? 'link-disabled' : 'p-link'"
                  v-tooltip.bottom="$toolips.standard($t('manageunmatchedbuyers.breadcrumb'))"
                  :disabled="loading"
                  @click="$router.currentRoute.name !== 'manage_unmatched_buyers' ? $router.push('manage_unmatched_buyers') : null">
            <i :class="loading ? 'topbar-icon-disabled fa fa-recycle':'topbar-icon fa fa-recycle'"></i>
            <span v-if="unmatchedBuyers > 0" class="badge">
              <AnimatedNumber :value-original="unmatchedBuyers" :precision="0" />
          </span>
            <span class="topbar-item-name">{{ $t('manageunmatchedbuyers.breadcrumb') }}</span>
          </button>
        </li>
      </template>
        <li>
          <div class="list-portfolio" style="display: flex; align-items: center">
            <span v-if="$vssWidth > 1300">{{ $t('topbar.selection') }}</span>
            <PortfolioDropdown v-model="selectedPortfolio" @update:modelValue="onPortfolioChange"
                               :disabled="editing || loading"></PortfolioDropdown>
            <template v-if="$methods.aclIsVisible('AppTopbar.createPortfolio')">
              <span v-if="$vssWidth > 1300">{{ $t('topbar.else') }}</span>
              <Button icon="fa fa-fw fa-plus"
                      id="createPortfolio"
                      :disabled="isNewPortfolio() || editing || loading"
                      :class="loading ? 'button-create-portfolio-inloading' : 'button-create-portfolio'"
                      @click="createPortfolio()"
                      :label="$t('common.buttons.new')" />
            </template>
          </div>
        </li>
    </ul>
    <ProgressBar v-if="loading" :value="progress" :showValue="false"
                 style="margin-top:1em; margin-bottom: -13px;height: 0.3em;border-radius: 0;" />
  </div>
</template>

<script>
import LoginService from './service/LoginService';
import CountryService from '@/service/CountryService';
import AnalysisService from './service/AnalysisService';
import BuyerService from './service/BuyerService';
import NotificationService from '@/service/NotificationService';
import UserPreferenceService from '@/service/UserPreferenceService';
import AnimatedNumber from './components/Common/AnimatedNumber';
//import jwt_decode from 'jwt-decode';
import { VueScreenSizeMixin } from 'vue-screen-size';
import PortfolioDropdown from '@/components/Common/PortfolioDropdown.vue';
import GridService from '@/service/GridService';
import { isEmpty } from '@/main';
import PortfolioService from '@/service/PortfolioService';

export default {
  mixins: [ VueScreenSizeMixin ],
  components: {
    PortfolioDropdown,
    AnimatedNumber,
  },
  props: {
    topbarMenuActive: Boolean,
    activeTopbarItem: String,
    profileMode: String,
    horizontal: Boolean
  },
  created() {
    this.portfolioService = new PortfolioService();
    this.countryService = new CountryService();
    this.loginService = new LoginService();
    this.analysisService = new AnalysisService();
    this.buyerService = new BuyerService();
    this.notificationService = new NotificationService();
    this.userPreferenceService = new UserPreferenceService();
  },
  beforeMount() {
    if (this.token) {
      //this.refreshJwt(jwt_decode(this.token).exp);
      this.loadNotificationsCount();
      this.countUnmatchedBuyersByPortfolio();
      this.formatPortfoliosDates();
      this.loadCountries();
    }
  },
  data() {
    return {
      silentRefresh: null,
      unmatchedBuyers: 0,
    };
  },
  computed: {
    reloadUnmatchedBuyers() {
      return this.$store.getters['reloadUnmatchedBuyers'];
    },
    newPortfolio() {
      return this.$store.getters['newPortfolio'];
    },
    indexOfNewSelectedPortfolio() {
      return this.$store.getters['indexOfNewSelectedPortfolio'];
    },
    selectedPortfolioIsChanged() {
      return this.$store.getters['selectedPortfolioIsChanged'];
    },
    selectedPortfolio: {
      get() {
        return this.$store.getters['selectedPortfolio'];
      },
      set(portfolio) {
        this.$store.commit('setSelectedPortfolio', portfolio);
      },
    },
    selectedPortfolioOriginal() {
      return this.$store.getters['selectedPortfolio'];
    },
    progress() {
      return this.$store.getters.progress;
    },
    loading() {
      return this.$store.getters['loading'];
    },
    editing() {
      return this.$store.getters['editing'];
    },
    topbarItemsClass() {
      return [ 'topbar-menu fadeInDown', {
        'topbar-menu-visible': this.topbarMenuActive,
      } ];
    },
    portfolios() {
      return this.$store.getters['portfolioList'];
    },
    selectedPeriod() {
      return this.$store.getters['selectedPeriod'];
    },
    comparedPeriod() {
      return this.$store.getters['comparedPeriod'];
    },
    user() {
      return this.$store.getters['user'];
    },
    token() {
      return this.$store.getters['token'];
    },
    role() {
      return this.$store.getters['userRole'];
    },
    notificationsCount() {
      return this.$methods.toNumber(this.$store.getters['notificationsCount']);
    },
    expiredCount() {
      if (this.portfolios != null) {
        const today = new Date();
        return this.portfolios.filter(p => p.endingDate != null && p.endingDate < today).length;
      }
      return 0;
    },
    userPreferenceSaved() {
      return this.$store.getters['userPreferenceSaved'];
    },
  },
  watch: {
    reloadUnmatchedBuyers() {
      if (this.reloadUnmatchedBuyers) {
        this.countUnmatchedBuyersByPortfolio();
      }
    },
    userPreferenceSaved() {
      if (this.userPreferenceSaved) {
        this.loadNotificationsCount();
        this.countUnmatchedBuyersByPortfolio();
        this.formatPortfoliosDates();
        this.loadCountries();
        this.reloadPortfolioAfterPreferenceSaved();
      }
    },
    selectedPortfolioIsChanged() {
      if (this.selectedPortfolioIsChanged) {
        this.selectedPortfolio = this.portfolios[this.indexOfNewSelectedPortfolio];
        this.$store.commit('setSelectedPortfolioIsChanged', false);
      }
    },
    progress() {
      if (this.progress > 100) {
        setTimeout(() => {
          this.$store.commit('setProgressLoaded', 0);
        }, 500);
      } else if (this.progress === 10) {
        setTimeout(() => {
          this.$store.commit('setProgressLoaded', 90);
        }, 500);
      }
    },
    comparedPeriod() {
    },
    selectedPortfolio() {
      if (isEmpty(this.selectedPortfolio) || isEmpty(this.selectedPortfolio.id))
        this.selectedPortfolio = { id: 0 };
      if (this.selectedPortfolio.customer == null)
        this.selectedPortfolio.customer = { contractList: [] };
      this.$store.commit('setSelectedPortfolio', this.selectedPortfolio);
      this.countUnmatchedBuyersByPortfolio();
      this.loadNotificationsCount();
      this.getUsernameDivisionByPortfolio();
    },
    token() {
      if (this.token) {
        this.loadNotificationsCount();
        this.countUnmatchedBuyersByPortfolio();
        this.formatPortfoliosDates();
        this.loadCountries();
      }
    },
  },
  methods: {
    onPortfolioChange(portfolio) {
      // This will trigger the selectedPortfolio setter which commits to store
      // and then the watcher will handle all the business logic
      this.selectedPortfolio = portfolio;
    },
    getUsernameDivisionByPortfolio() {
      if (!isEmpty(this.user) && !isEmpty(this.user.username) && !isEmpty(this.selectedPortfolio.id) && this.selectedPortfolio.id > 0 && this.role !== 'selectiodir') {
        this.$store.dispatch('startLoading');
        return this.userPreferenceService.getUsernameDivisionByPortfolio(this.user.username,
            this.selectedPortfolio.id).then(division => {
          this.$store.dispatch('stopLoading');
          this.$store.commit('setDivisionUser', division);
        }).catch(e => {
          console.log('errore: ' + e);
          this.$toast.add({
            severity: 'error',
            summary: this.$t('common.toasts.somethingWentWrong.summary'),
            detail: this.$t('common.toasts.somethingWentWrong.detail'),
          });
          this.$store.dispatch('resetLoading');
        });
      }
    },
    isNewPortfolio() {
      if (this.selectedPortfolioOriginal != null) {
        return this.selectedPortfolioOriginal.id < 0;
      }
      return false;
    },
    loadCountries() {
      this.countryService.getCountries().then(data => {
        this.$store.commit('buyers/setCountries', data);
      });
    },
    reloadPortfolioAfterPreferenceSaved() {
      if (this.selectedPortfolio && this.selectedPortfolio.id > 0) {
        this.portfolioService.getPortfolioById(this.selectedPortfolio.id)
            .then(portfolio => {
              this.selectedPortfolio = portfolio;
            })
            .catch(console.error);
      }
    },
    formatPortfoliosDates() {
      if (!this.$methods.isEmpty(this.portfolios)) {
        this.portfolios.forEach(portfolio => {
          if (portfolio.startingDate != null) {
            portfolio.startingDate = new Date(portfolio.startingDate);
            portfolio.startingDateFormatted = this.$methods.formatDate(portfolio.startingDate, this.$t('common.dateFormat'));
          }
          if (portfolio.contractExpiration != null) portfolio.contractExpiration = new Date(portfolio.contractExpiration);
          if (portfolio.endingDate != null) {
            portfolio.endingDate = new Date(portfolio.endingDate);
            portfolio.endingDateFormatted = this.$methods.formatDate(portfolio.endingDate, this.$t('common.dateFormat'));
            portfolio.remainingDaysToExpire = portfolio.endingDate - new Date();
          } else {
            portfolio.remainingDaysToExpire = 99999999999;
          }
        });
      }
    },
    countUnmatchedBuyersByPortfolio() {
      if (!this.newPortfolio && [ 'selectiodir', 'selectioage' ].includes(this.role)) {
        const search = {
          filters: [
            { fieldId: 'companyCode', match: 'eq', value: this.user.companyCode },
          ],
          returnData: { items: false, count: true },
        };
        if (this.selectedPortfolio.id > 0)
          search.filters.push({ fieldId: 'portfolioId', match: 'eq', value: this.selectedPortfolio.id });
        if (this.role !== 'selectiodir') {
          const portfolioIds = this.portfolios.map(p => p.id);
          search.filters.push({ fieldId: 'portfolioId', match: 'in', value: portfolioIds });
        }

        const gridService = new GridService();
        gridService.getUnmatchedBuyersSearch(search)
            .then(data => this.unmatchedBuyers = data.count);
      }
    },
    onMenuButtonClick(event) {
      this.$emit('menubutton-click', event);
    },
    onTopbarMenuButtonClick(event) {
      this.$emit('topbar-menubutton-click', event);
    },
    createPortfolio() {
      if (this.$router.currentRoute.name !== 'createportfolio')
        this.$router.push('create_portfolio');
    },
    loadNotificationsCount() {
      if (!this.user || !this.user.username) return;

      this.$store.dispatch('startLoading');
      this.notificationService.getNotificationsCount(this.user.username,
          (!this.$methods.isEmpty(this.selectedPortfolio) && this.selectedPortfolio.id > 0 ? this.selectedPortfolio.id : null)).then(data => {
        this.$store.commit('setNotificationsCount', data);
        this.$store.dispatch('stopLoading');
      }).catch(e => {
        this.$store.dispatch('resetLoading');
        console.log(e);
      });
    },
    // refreshJwt(expire) {
    //   if (this.user == null && this.silentRefresh != null) {
    //     clearInterval(this.silentRefresh);
    //   } else {
    //     const refreshToken = this.user.refresh;
    //     this.silentRefresh = setTimeout(() => {
    //       console.log('refreshJwt', this.user, JSON.parse(JSON.stringify(this.user)));
    //       this.loginService
    //           .refreshJwt(refreshToken)
    //           .then(data => {
    //             this.$store.commit('setToken', data);
    //           })
    //           .catch(e => {
    //             console.log('token expired', e);
    //             // this.$store.commit("resetState");
    //             if (this.$route.name !== 'login')
    //               this.$router.push('/login');
    //           });
    //     }, Math.floor(expire * 1000 - Date.now() - 5000)); //5 secs grace period
    //   }
    // },
  },
};

</script>
<style lang="scss" scoped>
@import "public/assets/sass/overrides/layout_variables";

.blue {
  color: $blue1;
}

.link-disabled {
  cursor: wait !important;
  border: none !important;
  background-color: transparent !important;
  position: relative;
  display: block;
  width: 44px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  border-radius: 50%;
}

.topbar-icon-disabled {
  color: rgba(67, 195, 191, 0.49);
  line-height: inherit;
  font-size: 24px;
}

.tag-username {
  line-height: 2em;
  font-size: 14px;
  font-weight: 400;
  padding: 0.5em;
  color: #43C3BF;
}

.button-create-portfolio {
  margin-top: 0.65em;
  float: right;
  color: #43C3BF;
  background-color: #FFF;
  border-color: #FFF;
  border-radius: 1em;
}

.button-create-portfolio-inloading {
  margin-top: 0.65em;
  float: right;
  cursor: wait !important;
  color: #43C3BF;
  background-color: #FFF;
  border-color: #FFF;
  border-radius: 1em;
}

.topbar-button-selected {
  color: #FFF;
  background-color: #43C3BF;
  border-color: #43C3BF;
  border-radius: 1em;
}

.badge {
  position: absolute;
  line-height: 1.2em;
  height: 1.2em;
  width: 1.2em;
  font-size: 0.8em;
  color: red;
  left: 2.2em;
  top: 0.1em;
  font-weight: bold;
}
</style>
